import React, { ReactElement } from "react";
import { useTranslation } from "react-i18next";
import { DeleteIcon } from "src/app/assets/icons/component-icons";
import ControlButton from "../base-button";

interface IProps {
  showLabel?: boolean;
  showTooltip?: boolean;
  className?: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  tooltipColor?: string;
}

const DeleteButton = ({
  showLabel = false,
  showTooltip = true,
  className = "",
  onClick,
  tooltipColor,
}: IProps): ReactElement => {
  const { t } = useTranslation();

  return (
    <ControlButton
      className={className}
      showLabel={showLabel}
      showTooltip={showTooltip}
      label={t("Delete")}
      tooltipColor={tooltipColor}
      data-testid="delete-button"
      onClick={(e) => {
        if (onClick) {
          onClick(e);
        }
      }}
    >
      <DeleteIcon />
    </ControlButton>
  );
};

export default DeleteButton;
